import _extends from "@babel/runtime/helpers/esm/extends";
import { jsx as ___EmotionJSX } from "@emotion/react";

const Form = props => ___EmotionJSX("form", _extends({
  noValidate: true
}, props));

export default Form;